const rankings = [
  { rank: 1, title: '逆流而上', category: '电视剧', hot: '9.8', tag: '热播中', tagColor: 'bg-primary-100 text-primary-700' },
  { rank: 2, title: '星辰彼岸', category: '电影', hot: '9.6', tag: '新上线', tagColor: 'bg-accent-100 text-accent-700' },
  { rank: 3, title: '迷雾追踪', category: '电视剧', hot: '9.4', tag: '高口碑', tagColor: 'bg-secondary-100 text-secondary-700' },
  { rank: 4, title: '山河无尽', category: '电影', hot: '9.2', tag: '热播中', tagColor: 'bg-primary-100 text-primary-700' },
  { rank: 5, title: '都市夜话', category: '电视剧', hot: '8.9', tag: '新上线', tagColor: 'bg-accent-100 text-accent-700' },
  { rank: 6, title: '长安十二夜', category: '电影', hot: '8.7', tag: '高口碑', tagColor: 'bg-secondary-100 text-secondary-700' },
];

function RankBadge({ rank }: { rank: number }) {
  const colors = [
    'bg-accent-500 text-white',
    'bg-primary-500 text-white',
    'bg-secondary-500 text-white',
  ];

  return (
    <div
      className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-heading ${
        rank <= 3 ? colors[rank - 1] : 'bg-background-200 text-foreground-600'
      }`}
    >
      {rank}
    </div>
  );
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            根据全网播放热度与用户口碑综合排名的影视热度榜单
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-background-200/70 overflow-hidden">
          {rankings.map((item, idx) => (
            <article
              key={item.title}
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-50 transition-colors cursor-pointer ${
                idx < rankings.length - 1 ? 'border-b border-background-100' : ''
              }`}
            >
              <RankBadge rank={item.rank} />

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-heading text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>

              <div className="flex items-center gap-1.5 text-sm flex-shrink-0">
                <i className="ri-fire-line text-accent-500"></i>
                <span className="font-heading text-foreground-800">{item.hot}</span>
                <span className="text-xs text-foreground-400 hidden sm:inline">分</span>
              </div>

              <div className="w-7 h-7 flex items-center justify-center text-foreground-300 flex-shrink-0">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}